import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { MessageService } from '../services/message.service';
import { GlobalVariables } from '../common/global-variables';

const stopsUrl = "assets/json/all-stops.json";
const stationsUrl = "assets/json/all-stops.json";
const arrivalsUrl = "https://www3.septa.org/hackathon/BusSchedules/?req1=";
const arrivalsRailUrl = "https://www3.septa.org/api/Arrivals/index.php?simple=1&req1=";
//const routeStopsUrl = "https://flat-api.septa.org/qa/stops/";
const routeStopsUrl = GlobalVariables.routeStopsUrl;
//const stopTimesUrl = "https://www3.septa.org/api/StopTimes/";
const stopTimesUrl = GlobalVariables.stopScheduleUrl;
//const tripStopTimesUrl = "https://www3.septa.org/api/Schedules/?trip_id=";
const tripStopTimesUrl = GlobalVariables.tripScheduleUrl;
const calendarUrl = "https://s3.amazonaws.com/flat-api.septa.org/qa/calendar/calendar.json";
//const tripStopTimesUrl = "https://www3.septa.org/api/StopTimes/Trip/?trip=";

@Injectable({
  providedIn: 'root'
})
export class StopsService {

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  public stops: any[] = [];

  constructor(private http: HttpClient, private messageService: MessageService) { }

  get(mode: string, id: string):Observable<any[]> {
    var url: string = stopsUrl;
    if (mode == "rail" || mode == "Regional Rail"){
      url = stationsUrl;
    }

    return this.http.get(url)
    .pipe(
      map ((array: any) => array = this.search(array, id)),
      tap (_ => this.log('fetched routes')),
      catchError (this.handleError<any[]>('get', []))
    );
  }

  getArrivals(mode: string, name: string, id: string):Observable<any[]> {
    var url: string = arrivalsUrl + id;

    if (mode == "rail"){
      url = arrivalsRailUrl + name;
    }

    return this.http.jsonp<any[]>(url, 'callback')
    .pipe(
      map ((array: any) => array = this.transformArrivals(array, mode)),
      tap (_ => this.log('fetched routes')),
      catchError (this.handleError<any[]>('get', []))
    );
  }

  getStops(id: string, direction: number):Observable<any[]> {
    var url: string = routeStopsUrl + id + '/stops.json';

    var data = this.http.get(url)
    .pipe(
      map ((array: any) => array = this.search_stops(array, direction)),
      tap (_ => this.log('Fetched stops')),
      catchError (this.handleError<any[]>('get', []))
    );

    return data;
  }


  getCalendar():Observable<any[]> {
    var data = this.http.get(calendarUrl)
    .pipe(
      map ((array: any) => array = this.formatCalendar(array)),
      tap (_ => this.log('fetched stop times')),
      catchError (this.handleError<any[]>('get', []))
    );

    return data;
  }

  formatCalendar(response: any): any{
    var weekday: any[] = [];
    weekday['bus'] = []; weekday['rail'] = [];
    var saturday: any[] = [];
    saturday['bus'] = []; saturday['rail'] = [];
    var sunday: any[] = [];
    sunday['bus'] = []; sunday['rail'] = [];
    var formatted: any[] = [];

    for(const array of response){
      // WD -> array(service ids)
      if(array['days'] == 62){
        weekday[array['mode']].push(array['service_id']);
      }
      // SAT -> array(service ids)
      if(array['days'] == 1){
        saturday[array['mode']].push(array['service_id']);
      }
      // SUNDAY -> array(service ids)
      if(array['days'] == 64){
        sunday[array['mode']].push(array['service_id']);
      } 
    }
    formatted['weekday'] = weekday;
    formatted['saturday'] = saturday;
    formatted['sunday'] = sunday;

    return formatted;
  }

  getStopTimes(route: string, direction: number,  stop: string):Observable<any[]> {
    var url: string = stopTimesUrl +  route + "/" + stop + "/schedule.json";
    var data = this.http.get(url)
    .pipe(
      map ((array: any) => array = this.search_stop_times(array, direction)),
      tap (_ => this.log('fetched stop times')),
      catchError (this.handleError<any[]>('get', []))
    );

    return data;
  }

  getTripStopTimes(trip: string):Observable<any[]> {
    var url: string = tripStopTimesUrl +  trip + "/schedule.json";
    var data = this.http.get(url)
    .pipe(
      map ((array: any) => array = this.format_trip_stop_times(array, 3)),
      tap (_ => this.log('fetched stop times')),
      catchError (this.handleError<any[]>('get', []))
    );

    return data;
  }

  /* GET stations whose name contains search term */
  public searchStations(mode: string, stop: string): Observable<any[]> {
    var url: string = stopsUrl;
    if (mode == "rail"){
      url = stationsUrl;
    }

    if (!stop.trim()) {
      return of([]);
    }
    return this.http.get(url)
    .pipe(
      map ((array: any) => array = this.search(array, stop)),
      tap (_ => this.log('fetched trains')),
      catchError (this.handleError<any[]>('get', []))
    );
  }

  private search(response: any, stop: string): any{
    var searched: any[] = [];
    for(const array of response){
      if(this.searchArray(array, stop)){
        searched.push(array);
      }
    }
    return searched;
  }

  private searchArray(array: any, stop: string){
    for( let i in array) {
      if(i == 'stop_name' || i == 'stop_id'){
        if(array[i] == stop){
          return true;
        }
      }
    }

    return false;
  }

  private search_stops(response: any, direction: number): any{
    var searched: any[] = [];
    for(const array of response){
      if(this.search_stop_direction(array, direction)){
        searched.push(array);
      }
    }
    return searched;
  }
  
  private search_stop_direction(array: any, direction: number){
    for( let i in array) {
      if(i == 'direction_id'){
        if(array[i] == direction){
          return true;
        }
      }
    }

    return false;
  }

  private search_stop_times(response: any, direction: number): any{
    var searched: any[] = [];
    for(const array of response){
      if(this.search_stop_times_direction(array, direction)){
        var hour: number = array['arrival_time'].toString().slice(0,2);
        var minute: string = array['arrival_time'].toString().slice(3,5);
        var period: string  = ' am';
        if(hour >= 12){
          period = ' pm';
        }

        if(hour > 23){
          hour =  hour - 24;
          if(hour < 12){
            period = ' am';
          }
          if(hour == 0){
            hour = 12;
          }
        }

        if(hour > 12 && hour < 24){
          hour =  hour - 12;
        }

        array['arrival_time'] = hour + ':' +  minute + period;
        searched.push(array);
      }
    }

    return searched;
  }

  private format_trip_stop_times(response: any, direction: number): any{
    var searched: any[] = [];

    for(const array of response){
      if(this.search_stop_times_direction(array, direction)){
        var hour: number = array['arrival_time'].toString().slice(0, 2);
        var minute: string = array['arrival_time'].toString().slice(3,5);
        var period: string  = ' am';
        if(hour >= 12){
          period = ' pm';
        }

        if(hour > 23){
          hour =  hour - 24;
          if(hour < 12){
            period = ' am';
          }
          if(hour == 0){
            hour = 12;
          }
        }

        if(hour > 12 && hour < 24){
          hour =  hour - 12;
        }

        array['actual_arrival_time'] = this.format_gtfs_actual_time(array['arrival_time']);
        array['arrival_time'] = hour + ':' +  minute + period;
        searched.push(array);
      }
    }

    searched.sort((a, b) => a.stop_sequence > b.stop_sequence ? 1 : -1);

    return searched;
  }
  
  private search_stop_times_direction(array: any, direction: number){
    for( let i in array) {
      if(i == 'direction_id'){
        if(array[i] == direction){
          return true;
        }
        if(direction == 3){
          return true;
        }
      }
    }

    return false;
  }

  private transform(response: any, stop: string){
    var transformed: any = this.search(response, stop)

    transformed.sort((a,b) => Date.parse(a["scheduled"]) - Date.parse(b["scheduled"]));
    return response
  }

  private transformArrivals(response: any, mode: string){
    var transformed: any[] = [];

    var temp: any[] = [];
    if(mode != 'rail'){
      for (let [key, value] of Object.entries(response)) {
        temp.push(value);
      }
      response = temp;
    }

    for (const d of (response as any)){

      if(mode == "rail"){
        var date = d.depart_time.substring(0, 10) + 'T' + d.depart_time.substring(11); //"1997-07-16T19:20+01:00" vs //2020-04-16 16:45:00.000

        transformed.push( {
          id: d.train_id,
          mode: "rail",
          route: d.line,
          scheduled: date,
          origin: d.origin,
          destination: d.destination,
          status: d.status == 'On Time' ? 'On-time' : d.status + ' late',
          type: d.service_type
        });
      }
      else{
        for(const e of d){
          if(e.DirectionDesc.includes('"')){
            e.DirectionDesc = e.DirectionDesc.replace('"','');
          }
          //DateCalender
          //"1997-07-16T19:20+01:00" vs 04/17/20 12:59 pm

          transformed.push( {
            id: e.Route,
            mode: "transit",
            route: e.Route,
            scheduled: e.DateCalender,
            origin: e.Route,
            destination: e.DirectionDesc,
            status: 'Scheduled',
            type: 'Scheduled'
          });
        }
      }
    }
    transformed.sort((a,b) => Date.parse(a["scheduled"]) - Date.parse(b["scheduled"]));
    return transformed
  }

  private format_gtfs_actual_time(time: any) {

    var current_date: Date = new Date();

    var hour: number = time.toString().slice(0, 2);
    var minute: string = time.toString().slice(3, 5);
    var period: string = ' am';

    if (hour <= 12) {
      current_date.setHours(hour);
    }

    if (hour >= 12) {
      period = ' pm';
    }

    if (hour > 23) {
      hour = hour - 24;
      if (hour < 12) {
        period = ' am';
      }
      if (hour == 0) {
        hour = 12;
      }

      current_date.setDate(current_date.getDate() + 1);
      current_date.setHours(hour);
    }

    if (hour > 12 && hour < 24) {
      current_date.setHours(hour);
      hour = hour - 12;
    }

    current_date.setMinutes(Number(minute));
    current_date.setSeconds(0);

    return current_date.getTime();
  }

  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log('${operation} failed: ${error.message}');

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  /** Log a RouteService message with the MessageService */
  private log(message: string) {
    this.messageService.add(`RouteService: ${message}`);
  }
}
